const Songs = {
    complete: 0,
    gameplay: 1,
    title: 2
}

const State = {
    init: 0,
    title: 1,
    gameplay: 2,
    complete: 3
}

class GameState {

    constructor() {
        this.stateSubject = new rxjs.Subject();
        this.isInVRSubject = new rxjs.Subject();
        this.cryingKidsSubject = new rxjs.Subject();
        this.holdingSubject = new rxjs.Subject();
        this.scoreSubject = new rxjs.Subject();
    }
    reset() {
        this._holding = [];
        this.holdingSubject.next(this._holding);
        this._cryingKids = 0;
        this.cryingKidsSubject.next(this._cryingKids);
        this._score = 0;
        this.scoreSubject.next(this._score);
    }

    _state = State.Init;
    set state(value) {
        this._state = value;
        this.stateSubject.next(value);
    }
    get state() {
        return this._state;
    }

    _isInVR = false;
    set isInVR(value) {
        this._isInVR = value;
        this.isInVRSubject.next(value);
    }
    get isInVR() {
        return this._isInVR;
    }

    /**
     * @type Array<GameObject> objects the player is holding
     */
    _holding = [];

    /**
     * 
     * @param {GameObject} what 
     */
    grab(what) {
        this._holding.push(what);
        this.holdingSubject.next(this._holding);
    }

    ungrab(what) {
        this._holding = this._holding.filter(
            x => x.type !== what.type &&
                x.subtype !== what.subtype);

        this.holdingSubject.next(this._holding);
    }
    _score = 0;
    set score(value) {
        this._score = value;
        this.scoreSubject.next(value);
    }
    get score() {
        return this._score;
    }

    _cryingKids = 0;
    addCryingKid() {
        this._cryingKids++;
        this.cryingKidsSubject.next(this._cryingKids);
    }
}

class Instructions {

    constructor() {
        this.currentInstruction = 0;
        this.instructions = [
            Sounds.grabTheToy,
            Sounds.lookAtTheList,
            Sounds.wrapTheGift,
            Sounds.addTheBow,
            Sounds.dropTheGift,
            Sounds.wellDone,
        ];
        this.steps = {}
        this.lookAtTimout = null;
    }

    play(step) {
        if (this.steps[step]) return false;
        if (this.currentInstruction > this.instructions.length - 1) {
            return false;
        }
        this.steps[step] = true;

        if (this.lookAtTimout) {
            clearTimeout(this.lookAtTimout);
            this.currentInstruction++;
            this.lookAtTimout = null;
        }
        if (step == 'grab') {            
            this.lookAtTimout = setTimeout(() =>{
                this.lookAtTimout = null;                
                this.play('lookAtList');
            }, 10000);
        }
        window.SW.soundEffects.playSound(this.instructions[this.currentInstruction]);
        this.currentInstruction++;
        return true;
    }
}

window.SW = {}

if ('onSceneLoaded' in window.WL) {
    window.WL.onSceneLoaded.push(() => {
        window.SW.gameState = new GameState();
        window.SW.soundEffects = new SoundfxPlayer();
        window.SW.instructions = new Instructions();
    });
}


/**
 * @typedef {Object} GameObject
 * @property {'Gift'|'Paper'|'Ribbon'} type
 * @property {'train'|'star'|'candy'|'chest'|'horse'|'xmas'|'red'|'yellow'|'blue'|'green'|'purple'} subtype depends on type 
 */